module.exports = __webpack_public_path__ + "img/hz-xlk.6652388b.png";